import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormGroup, FormControl,ValidationErrors, ValidatorFn, AbstractControl  } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { OrdersService } from '../../services/orders.service';
import { Location ,DatePipe } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';

@Component({
	selector: 'app-vendor-create',
	templateUrl: './vendor-create.component.html',
	styleUrls: ['./vendor-create.component.scss']
})
export class VendorCreateComponent implements OnInit {

	adressType = '';
	@ViewChild('addresstext') addresstext: any;
	autocompleteInput: string;

	vendorid: any = '';
	vendorselected = false;
	vd: any = [];
	term: any = '';

	taxgroup: any = '';
	taxes: any = [];
	currencies: any = [];
	bankaccounts: any = [];
	types: any = [];
	zones: any = [];
	vendorForm: any = false;
	//todo move this to config
	defaults = {
		country: 'United States',
		region: 'NY',
		holdreason: '1',
		currency: 'USD',
		terms: 'N30',
		salestype: 'A1',
		customertype: '1',
		discount: 0,
		credit: 1000,
		email_invoice: false,
		requirepo: false,
		email_statement: false,
		interest: 3,
		warehouse: '01',
		shipvia: '1',
		area: '01',
		territory: '01',
		salesman: '01',
		disabled: false,
		tirefee: true,
		taxauth: '119',
		branchcode: '00',
		bank: '1010',
		remit: '1',
		suppliertype: '2',
	};

	color = '';
	address: any = '';
	active_vendors: any = false;
	supplieridManuallyEdited: boolean = false;

	constructor(private route: ActivatedRoute, private vendorService: VendorService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private fb: UntypedFormBuilder, public globalsService: GlobalsService) {

		this.color = this.globalSearchService.getColor();

	}

	paymentterms: any = [];

	ngOnInit(): void {

		this.vendorService.getVendors().subscribe((r) => {
			this.active_vendors = r;
		})

		this.vendorForm = this.fb.group({
			supplierid: ['', [Validators.required, this.vendIdExists()]],
			suppname: ['', [Validators.required]],
			email: ['', []],
			address1: ['', [Validators.required]],
			address2: ['', []],
			address3: ['', [Validators.required]],
			address4: [this.defaults.region, [Validators.required]],
			address5: ['', [Validators.required]],
			address6: [this.defaults.country, [Validators.required]],
			supptype: [this.defaults.suppliertype, [Validators.required]],
			currcode: [this.defaults.currency, [Validators.required]],
			//suppliersince: ['', [Validators.required]],
			paymentterms: [this.defaults.terms, [Validators.required]],
			bankact: [this.defaults.bank, [Validators.required]],
			remittance: [this.defaults.remit, [Validators.required]],
			taxgroupid: [this.defaults.taxauth, [Validators.required]],
			factorcompanyid: [''],
			telephone: ['', [Validators.required]],
			url: ['']
		});

		// Subscribe to vendor name changes to auto-generate ID
		this.vendorForm.get('suppname').valueChanges.subscribe((name) => {
			if (name && !this.supplieridManuallyEdited) {
				const autoId = this.generateVendorId(name);
				this.vendorForm.get('supplierid').setValue(autoId, { emitEvent: false });
			}
		});

		// Track manual edits to supplierid
		this.vendorForm.get('supplierid').valueChanges.subscribe(() => {
			if (this.vendorForm.get('supplierid').dirty) {
				this.supplieridManuallyEdited = true;
			}
		});
	}

	updateVendor() {
		if (this.vendorForm.valid) {
			this.vendorService.saveVendor(this.vendorForm.value).subscribe({
				next: (details) => {
					this.router.navigate(['vendors/' + this.vendorForm.controls.supplierid.value]);
				},
				error: (error) => {
					// Handle server-side validation errors
					if (error.error && error.error.message) {
						const errorMsg = error.error.message.toLowerCase();
						if (errorMsg.includes('duplicate') || 
							errorMsg.includes('already exists') ||
							errorMsg.includes('supplierid') ||
							errorMsg.includes('unique constraint')) {
							this.vendorForm.get('supplierid').setErrors({ duplicate: true });
							this.globalSearchService.showNotification(
								'Vendor ID already exists. Please choose a different ID.',
								'danger',
								'bottom',
								'right'
							);
						} else {
							this.globalSearchService.showNotification(
								error.error.message || 'Error saving vendor',
								'danger',
								'bottom',
								'right'
							);
						}
					} else if (error.message) {
						this.globalSearchService.showNotification(
							error.message || 'Error saving vendor',
							'danger',
							'bottom',
							'right'
						);
					}
				}
			});
		} else {
			this.getFormValidationErrors();
		}
	}

	back(): void {
		this.location.back()
	}

	ngAfterViewInit() {
		this.globalsService.getTypes().subscribe(async details => {
			this.types = details;
		});

		this.globalsService.getBankAccounts().subscribe(async details => {
			this.bankaccounts = details;
		});

		this.globalsService.getTerms().subscribe(async details => {
			this.paymentterms = details;
		});

		this.globalsService.getTaxes().subscribe(async details => {
			this.taxes = details;
		});

		this.globalsService.getCurrencies().subscribe(async details => {
			this.currencies = details;
		});

		this.globalsService.getDefaultZones().subscribe(async details => {
			this.zones = details;
		});

	}

	updateZones(value: any) {
		if (value && value.value) {
			const countryId = this.zones.countries.find((c: any) => c.name === value.value);
			if (countryId) {
				this.globalsService.getCountryZones(countryId.country_id).subscribe((details: any) => {
					this.zones.zones = details.zone;
				});
			}
		}
	}

	getAddress(place: object) {

		this.address = place['formatted_address'];
		const componenets = place['address_components'];
		const name = place['name'];
		const phone = place['formatted_phone_number'];
		const website= place['website'];

		const address1 = this.parseComponentShortName(componenets, ['street_number','route']);
		const address2 = this.parseComponentShortName(componenets, ['subpremise']);
		const address3 = this.parseComponentShortName(componenets, ['locality']);
		const address4 = this.parseComponentShortName(componenets, ['administrative_area_level_1']);
		const address5 = this.parseComponentShortName(componenets, ['postal_code']);
		const address6 = this.parseComponentLongName(componenets, ['country']);

		this.vendorForm.get('address1').setValue(address1)
		this.vendorForm.get('address2').setValue(address2)
		this.vendorForm.get('address3').setValue(address3)
		this.vendorForm.get('address4').setValue(address4)
		this.vendorForm.get('address5').setValue(address5)
		this.vendorForm.get('address6').setValue(address6)

		if(name) {
			this.vendorForm.get('suppname').setValue(name);
			// Auto-generate vendor ID from name if not manually edited
			if (!this.supplieridManuallyEdited) {
				const autoId = this.generateVendorId(name);
				this.vendorForm.get('supplierid').setValue(autoId);
			}
		}

		if(phone) {
			this.vendorForm.get('telephone').setValue(phone)
		}

		if(website) {
			this.vendorForm.get('url').setValue(website)
		}

	}

	private vendIdExists(): ValidatorFn{
		return (control:AbstractControl) : ValidationErrors | null => {
			const value = control.value.toUpperCase();
			if (!value) {
				return null;
			}else{
				return this.active_vendors.filter((c) => {if (c.supplierid.toUpperCase() == value){return c}}).length > 0 ? { isNewvendor:true } : null
			}
		}
	}

	private parseComponentShortName(componenets: any , types: any) {

		const result= [];
		componenets.forEach( (comp: any) => {
			const compa = comp.types.map((local: any) => {
				if(types.includes(local)) {
					const adda = (comp.short_name) ? comp.short_name : '';
					result.push(adda);
				}
			});
		})
		return result.join(' ');
	}

	private parseComponentLongName(componenets: any , types: any) {
		const result= [];
		componenets.forEach( (comp: any) => {
			const compa = comp.types.map((local: any) => {
				if(types.includes(local)) {
					const adda = (comp.long_name) ? comp.long_name : '';
					result.push(adda);
				}
			});
		})
		return result.join(' ');
	}

	getFormValidationErrors() {
		Object.keys(this.vendorForm.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = this.vendorForm.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					this.vendorForm.markAllAsTouched();
					this.globalSearchService.showNotification(key + ' ' + keyError + ' ' + controlErrors[keyError], 'danger', 'bottom', 'right')

				});
			}
		});
	}

	/**
	 * Generate a unique vendor ID from vendor name (max 10 characters)
	 * @param name Vendor name
	 * @returns Generated vendor ID
	 */
	private generateVendorId(name: string): string {
		if (!name) return '';
		
		// Remove common business suffixes and clean up the name
		let cleanName = name
			.replace(/^\s+(Inc|LLC|Ltd|Corp|Corporation|Company|Co|Inc\.|LLC\.|Ltd\.|Corp\.)/i, '')
			.replace(/\s+(Inc|LLC|Ltd|Corp|Corporation|Company|Co|Inc\.|LLC\.|Ltd\.|Corp\.)$/i, '')
			.trim();
		
		// Extract initials from first words, uppercase
		let id = cleanName
			.split(' ')
			.filter(word => word.length > 0)
			.map(word => word.charAt(0).toUpperCase())
			.join('');
		
		// If name has few words, take first 2-3 letters of each word instead
		if (id.length < 3) {
			id = cleanName
				.split(' ')
				.map(word => word.substring(0, 2).toUpperCase())
				.join('')
				.substring(0, 6);
		}
		
		// Limit to 10 characters
		id = id.substring(0, 10);
		
		// If ID is too short, pad with first available chars from name
		if (id.length < 3) {
			const padded = cleanName.replace(/\s/g, '').substring(0, 10).toUpperCase();
			id = padded.length > id.length ? padded : id;
		}
		
		// Check if ID exists and make it unique
		const existingIds = this.active_vendors?.map((v: any) => v.supplierid.toUpperCase()) || [];
		let uniqueId = id;
		let counter = 1;
		
		while (existingIds.includes(uniqueId.toUpperCase()) && counter < 1000) {
			const suffix = counter.toString();
			const maxBaseLength = 10 - suffix.length;
			uniqueId = id.substring(0, maxBaseLength) + suffix;
			counter++;
		}
		
		return uniqueId;
	}

}
